<script setup lang="ts">
  import { MpCard, MpDivider, MpText } from '@borg/ui';

  const props = defineProps<{
    tag: string | undefined | null;
  }>();

  const NUMBER_OF_ARTICLES_TO_SHOW = 5;
  const currentPage = ref(1);

  const { data: articlesByTopic } = await articlesByTopicsRepository.getManyPaginated(
    currentPage,
    props.tag || '',
  );
</script>

<template>
  <MpCard
    v-if="articlesByTopic && articlesByTopic.items.length > 0"
    border
  >
    <MpText as="h4">
      {{ $t('ORGANIZATION_CARD.RELATED_ARTICLES') }}
    </MpText>
    <MpDivider />
    <div class="articles">
      <ArticlePreview
        v-for="article in articlesByTopic.items.slice(0, NUMBER_OF_ARTICLES_TO_SHOW)"
        :key="article.id"
        :article="article"
        :show-image="false"
      />
      <LinksLocale
        v-if="articlesByTopic.total > NUMBER_OF_ARTICLES_TO_SHOW"
        :to="{ name: 'advices-search', query: { tag } }"
        target="_blank"
      >
        <MpText
          semibold
          class="articles__show-more-button"
        >
          {{ $t('ORGANIZATION_CARD.SHOW_ALL_ARTICLES', { n: articlesByTopic.total }) }}
        </MpText>
      </LinksLocale>
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .articles {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-60);

    &__show-more-button {
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
